module.exports = "<div class=\"project-menu cursor\">\n    <ul>\n        <li>Edit</li>\n        <li>Duplicate</li>\n        <li>Delete</li>\n        <li>Show Report</li>\n        <li>Action</li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/project/pipeline/projectMenu/projectMenu.tpl.html
// module id = 1803
// module chunks = 0